<template>
	<button
		v-on="$listeners"
		class="schedule-row button-clear"
		:class="{
			'schedule-row--more': data.type == 'non',
			'schedule-row--no-shadow': !shadow
		}"
		:style="insetCalendarColorVar(data.calendarThemeColor)"
	>
		<template v-if="data.type == 'non'">
			<div class="schedule-row__content">{{ $t('enterprise.more') }}</div>
			<SvgIcons name="right-light" />
		</template>
		<div v-else class="schedule-row__content text-overflow">{{ formatScheduleRow }}</div>
	</button>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';
import { useScheduleCore, checkScheduleHourHide, getScheduleThemeName } from '@/hooks/calendar/useScheduleCore';

const props = defineProps({
	data: {
		type: Object,
		default: () => {}
	},
	shadow: {
		type: Boolean,
		default: true
	}
});
const checkScheduleThemeName = computed(() => getScheduleThemeName(props.data));
const formatDate = date => {
	if (!date.scheduleStartTime) return '-';

	const disVisibleHour = checkScheduleHourHide(date);
	if (disVisibleHour) {
		return '';
	}

	return moment(date.scheduleStartTime).format('HH:mm');
};
const formatScheduleRow = computed(() => {
	const { scheduleStartTime, scheduleEndTime } = props.data;
	const isSameDay = moment(scheduleStartTime).isSame(scheduleEndTime, 'day');
	if (!isSameDay) return checkScheduleThemeName.value; // 跨天的日程 不直接展示时间
	return `${formatDate(props.data)} ${checkScheduleThemeName.value}`;
});

const { insetCalendarColorVar } = useScheduleCore();
</script>

<style lang="less" scoped>
.button-clear {
	appearance: none; /* 移除某些浏览器的默认样式 */
	padding: 0; /* 移除内边距 */
	border: none; /* 移除边框 */
	background-color: transparent; /* 设置背景色为透明 */
	font: inherit; /* 使用继承的字体样式 */
	cursor: default; /* 使用默认光标样式 */
	text-align: left; /* 按需设置文本对齐方式 */
	-webkit-appearance: none; /* 移除WebKit内核浏览器的默认样式 */
	display: block;
	width: 100%;

	&:hover,
	&:focus,
	&:active {
		outline: none; /* 移除焦点轮廓线 */
	}
}
.schedule-row {
	color: #000;
	border-radius: 2px;
	background: #fff;
	position: relative;
	cursor: pointer;
	margin-bottom: 8px;
	transition: all 0.1s ease;

	&:focus {
		color: var(--theme-color);
	}

	&--no-shadow {
		box-shadow: none;
		margin-bottom: 8px;
		background: transparent;
		transition: background 0.17s ease-in-out;

		&:hover {
			background: var(--theme-color-gradient-003);
		}
	}

	&--active {
		background: var(--theme-color-gradient-003);
	}

	&:last-child {
		margin-bottom: 0;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 2px;
		height: 10px;
		background: var(--calendar-color);
	}

	&--more {
		display: flex;
		justify-content: center;
		align-items: center;

		&::before {
			display: none;
		}

		&:hover {
			color: var(--theme-color);

			.svg-icon {
				color: var(--theme-color) !important;
			}
		}

		.schedule-row__content {
			margin-left: 0;
		}

		.svg-icon {
			margin-left: 4px;
			font-size: 16px;
			color: #1d2129 !important;
		}
	}

	&__content {
		margin-left: 4px;
		font-size: 12px;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}
}
</style>
